<template>
    <div class="ListingOverview">
        <h5>{{'Property Overview' | language}}</h5>
        <table>
            <tbody>
                <tr>
                    <td><strong>{{'Property ID' | language}}</strong></td>
                    <td>{{property.int_property_id}}</td>
                </tr>
                <tr>
                    <td><strong>{{'Property Type' | language}}</strong></td>
                    <td>{{language === 'english' ?  property.property_type.str_property_type_name_en : property.property_type.str_property_type_name_jp}}</td>
                </tr>
                <tr>
                    <td><strong>{{'Rooms' | language}}</strong></td>
                    <td v-if="property.room">{{language === 'english' ?  property.room.str_room_short_name_en : property.room.str_room_short_name_jp}}</td>
                </tr>
                <tr>
                <td><strong>{{'Floor' | language}}</strong></td>
                    <td v-if="property.str_floor">{{ property.str_floor + ' of ' + property.building.int_floors }}</td>
                </tr>
                <tr>
                    <td><strong>{{'Construction' | language}}</strong></td>
                    <td>{{language ==='english' ?  property.building.build_type.str_build_type_en : property.building.build_type.str_build_type_jp}}</td>
                </tr>
                <tr>
                    <td><strong>{{'Available Date' | language}}</strong></td>
                    <td>
                        <span v-if="property.dat_available_from">
                            {{property.dat_available_from | moment('DD-MM-YYYY')}}
                        </span>
                        <span v-else class="ListingOverview__Available">
                            {{'Available Now' | language}}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td><strong>{{'Serviced Property' | language}}</strong></td>
                    <td>
                        <span v-if="property.bit_serviced_property">{{'Yes' | language}}</span>
                        <span v-else>{{'No' | language}}</span>
                    </td>
                </tr>
                <tr>
                    <td><strong>{{'Size' | language}}</strong></td>
                    <td>{{property.flt_size}}m<sup>2</sup></td>
                </tr>
                <tr>
                    <td><strong>{{'Year Built' | language}}</strong></td>
                    <td>
                        <span v-if="property.building && property.building.int_year_built">
                            {{property.building.int_year_built}}
                        </span>
                        <span v-else>Unknown</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapState } from 'vuex'
    export default {
        name: 'listing-overview',
            data: function() {
                return {
            }
        },
        props: {
            property: Object
        },
        computed: {
        ...mapState({
            language:(state) => {
            return state.general.language
            }
        }),
        },
        created() {
        }
    }
</script>

<style lang="scss">
    .ListingOverview {
        display: inline-block;
        width: 100%;

        &__Available {
            font-weight: 600;
        }

        table {
            table-layout: fixed;

            tbody {
                padding: 0;
            }

            tr {
                td {
                    &:first-child {
                        padding-left: 0;
                    }
                }
            }
        }
    }
</style>
